// extracted by mini-css-extract-plugin
export var TagsList = "TagsList_hGgIR";